import { CSSProperties, FC, ReactNode } from "react"

import { CircularProgress, Fab, FabProps, Tooltip } from "@mui/material"
import IconWrapper from "components/common/icon/iconWrapper"

interface IProps extends Omit<FabProps, "onClick"> {
  isLoading?: boolean
  tooltipText?: string
  Icon: ReactNode
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  iconStyle?: CSSProperties
}

const FabIconButton: FC<IProps> = ({
  Icon,
  onClick,
  tooltipText,
  isLoading,
  iconStyle,
  ...fabProps
}) => {
  return (
    <Tooltip
      title={tooltipText || ""}
      slotProps={{
        tooltip: {
          sx: {
            whiteSpace: "pre-line",
          },
        },
      }}
    >
      {/* A disabled native button doesn't fire hover events in every browser — the
          Tooltip needs a non-disabled element (this span) to anchor to. */}
      <span>
        <Fab size="small" onClick={onClick} aria-label={tooltipText} {...fabProps}>
          <IconWrapper style={iconStyle}>
            {isLoading ? <CircularProgress size={24} /> : Icon}
          </IconWrapper>
        </Fab>
      </span>
    </Tooltip>
  )
}

export default FabIconButton
